module.exports = __webpack_public_path__ + "static/media/21_Natascha_L_webfinal.7ac41a43.jpg";